import { Entity } from "./Entity"
import { DateString, TimeString, TimestampString, Uuid } from "./global"



/**
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-27655
  */
export interface Task extends Entity<Task> {
	id: number
	taskUuid: Uuid

	//#region DRAFT
	/** preso dal /api/tasks_drafts/from_template */
	taskDraftUuid: Uuid
	/** points to the production task (if exist) or a new uuid that will match the task when created */
	refToTaskUuid: Uuid
	/** if the tasks is linked to a cycle */
	cycleUuid: Uuid
	//#endregion

	relatedTo: RELATED_TO
	farmId: number

	/** only if if the task is linked to a grow unit */
	growUnitId: number

	subject: string
	scope: string
	opsGroup: string
	description: string

	isCancelled: boolean
	isClosed: boolean
	firstClosedAt: DateString
	lastClosedAt: DateString
	/** la data del TASK YYYY-MM-DD */
	dueDate: DateString
	/** l'ora del TASK HH:MM */
	dueTime: TimeString

	/** soomato a "trolleysPoints" permette di calcolare "totalPoints"  */
	points: number 			// float 
	/** soomato a "points" permette di calcolare "totalPoints"  */
	trolleysPoints: number 	// float  
	/** è praticamente la somma di "points" + "trolleysPoints" */
	totalPoints: number 	// float 
	/** (true) cancella il TASKs se il CYCLE abbinato è stato REJECTED */
	cancelIfCycleRejected: boolean
	/** (true) updates the rendering of the TASKs */
	updatesYield: boolean
	taskTemplateId: number
	/** if this property is null then existing metadata remain  */
	metadata: any,
	/** if this property is null then existing subtasks remain  */
	subtasks: SubTask[]
	/** used in resync with template.index the subtasks resynced from template */
	resyncedSubtasks: SubTask[]

	createdAt: TimestampString

	/** numero di attachments assegnati a questo task */
	numberOfAttachments?: number
}

export enum RELATED_TO {
	FARM = "farm",
	GROW_UNIT = "grow_unit",
	CYCLE = "cycle",
}

/**
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-27655?block=block-d09bed45-c189-44c8-bf45-a7f5111e4f5e
 */
export interface SubTask {
	id?: number
	taskId?: number
	subtaskTemplateId?: number
	subtaskUuid?: Uuid
	subject?: string
	description?: string
	layerNumber?: number
	/** se valorizzato visualizza il valore `inputValue` */
	input?: boolean
	/** valore inserito dall'utente */
	inputValue?: any
	createdAt?: TimestampString
	updatedAt?: TimestampString
}

/**
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-27655?block=block-e2abd204-2204-449d-adf6-d3ca401c37c7
 * gli scope disponibili per un TASK
 */
export enum TASK_SCOPE {
	// usato per i TASK che non sono ancora stati creati
	// ma sono stati creati come DRAFT
	PREVIEW = "preview",

	PRODUCTION = "production",
	PACKAGING = "packaging",
	CLEANING = "cleaning",
	MAINTENANCE = "maintenance",
	QUALITY = "quality",
	AGRO = "agro",
	MACHINERY = "machinery",
}

/**
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-27655?&block=block-6446db8b-73e4-41d2-8e7e-edbaf82530dd
 */
export interface Scopes {[key:string]: string[]}
